/**
 * 공유 기능 관련 상수 정의
 */

// 공유 메모 설정
export const SHARE_NOTE_MAX_LENGTH = 200;

// 기본 공유 설정
export const DEFAULT_SHARE_SETTINGS = {
  expirationHours: 24,
  maxUses: 5,
  includePassword: true,
  includeNotes: false,
  shareNote: ''
};

// 만료 시간 옵션
export const EXPIRATION_OPTIONS = [
  { value: 1, label: '1시간' },
  { value: 6, label: '6시간' },
  { value: 24, label: '24시간' },
  { value: 72, label: '3일' },
  { value: 168, label: '1주일' }
];

// 최대 사용 횟수 옵션
export const MAX_USES_OPTIONS = [
  { value: 1, label: '1회' },
  { value: 3, label: '3회' },
  { value: 5, label: '5회' },
  { value: 10, label: '10회' },
  { value: 20, label: '20회' }
];

// 메모 표시 설정
export const NOTE_DISPLAY_MAX_LENGTH = 100; // 긴 메모 자르기 기준

// 공유 메모 placeholder 텍스트
export const SHARE_NOTE_PLACEHOLDER = "예: 김철수 대리에게 개발 서버 접속용, 프로젝트 팀원 공용 계정 등...";

// 공유 상태
export const SHARE_STATUS = {
  ACTIVE: 'active',
  WARNING: 'warning', 
  COMPLETED: 'completed',
  EXPIRED: 'expired'
};
